export default __webpack_public_path__ + "static/media/Websites-washington.edu2.e4238b1d.png";